
/**
 * From: https://www.npmjs.com/package/@react-keycloak/web
**/
import Keycloak from 'keycloak-js'

import config from 'config'

const keycloak = new Keycloak({
  url:      config.keycloak_url,
  realm:    config.keycloak_realm,
  clientId: config.keycloak_client_id,
  onLoad:  'check-sso',
})

export default keycloak
